import React, { useRef } from 'react';
import { useField } from 'formik';
import InfoIcon from '../../../assets/icons/ic-info.svg';
import { Tooltip, OverlayTrigger, FormGroup, FormLabel } from 'react-bootstrap';

interface IProps {
  name: string;
  labelText?: string;
  toolTipText?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  required?: boolean;
  isDate?: boolean;
}

const TextInput = ({
  name,
  labelText = '',
  toolTipText = '',
  disabled = false,
  fullWidth = false,
  required = false,
  isDate = false,
}: IProps) => {
  const [field, meta] = useField(name);
  const value = isDate
    ? field.value
      ? new Date(field.value).toString().substring(4, 15)
      : ''
    : field.value || '';
  return (
    <FormGroup className={`form-group ${fullWidth ? 'full-width' : ''}`}>
      <FormLabel className={`label-wrapper ${toolTipText && 'with-tooltip'}`}>
        {required && <span className="required-indicator">*</span>}
        {/* // to delete after testing */}
        {/* {labelText} */}
        {/* {toolTipText && (
          <>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id={`tooltip-${field.name}`}>{toolTipText}</Tooltip>
              }
            >
              <img
                src={InfoIcon}
                alt="info img"
                className="tooltip-trigger"
                data-toggle="tooltip"
              />
            </OverlayTrigger>
          </>
        )} */}
      </FormLabel>
      <input
        type="text"
        id={field.name}
        className={`form-control ${meta.error && 'is-invalid'}`}
        {...field}
        value={value}
        disabled={disabled}
      />
      {meta.error && <p className="error-wrapper">{meta.error}</p>}
    </FormGroup>
  );
};

export { TextInput };
